import React from 'react'
import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next'

const CompanyName = () => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register('companyName', {
        maxLength: {
          value: 255,
          message: t('validation:max.string', {
            attribute: t('commonFormFields:companyName.label'),
            length: 255
          })
        },
        minLength: {
          value: 2,
          message: t('validation:min.string', {
            attribute: t('commonFormFields:companyName.label'),
            length: 2
          })
        },
        required: t('validation:required')
      })}
      error={errors.companyName?.message as string}
      label={t('commonFormFields:companyName.label')}
    />
  )
}

export default CompanyName
